import { NotificationApi, NotificationCountResponse, NotificationDetailResponse } from '../../apis/notification';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../types';
import { NotificationFilter } from '@supersports/services';
import { userPolling } from '../userSlice';

interface NotificationSlice {
  list: NotificationDetailResponse[];
  count: NotificationCountResponse;
  isLoading: boolean;
}

export const initialState: NotificationSlice = {
  list: [],
  isLoading: false,
  count: {
    NewsHistory: 0,
    PrivateMessage: 0,
  },
};

export const getAllNotifications = createAsyncThunk(
  'notification/getAllNotifications',
  async (filter: NotificationFilter, { getState }) => {
    const state = getState() as RootState;
    const userInfo = state.user;

    if (userInfo?.Uuid) {
      return await NotificationApi.getAllNotifications(filter, userInfo);
    }

    return [];
  }
);

export const countNotifications = createAsyncThunk('notification/countNotifications', async (_, { getState }) => {
  const state = getState() as RootState;
  const userInfo = state.user;

  if (userInfo?.Uuid) {
    return await NotificationApi.countNotifications(userInfo);
  }

  return { NewsHistory: 0, PrivateMessage: 0 };
});

const notificationSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllNotifications.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getAllNotifications.fulfilled, (state, action) => {
        state.list = action.payload;
        state.isLoading = false;
      })
      .addCase(countNotifications.fulfilled, (state, action) => {
        state.count = action.payload;
      })
      .addCase(userPolling.fulfilled, (state, action) => {
        if (action.payload) {
          state.count = action.payload.Notification.Data;
        }
      });
  },
});

const notificationReducer = notificationSlice.reducer;

export default notificationReducer;
